export default __webpack_public_path__ + "static/artistBox-serina-maiko-4a7104190260b82885b3cdbd456b4b8c.png";